import React from "react";

export default function History() {
  return <div>History</div>;
}
